;(function() {
  'use strict'

  Controller.$inject = ["mediaView", "cloudinaryService"];
  angular.module('app.survey').component('surveyChoice', {
    controller: Controller,
    templateUrl: 'survey-choice.html',
    bindings: {
      type: '@',
      label: '<',
      image: '<',
      rankValue: '<rank',
      onClick: '&',
      isSelected: '<',
      isDisabled: '<',
      textCapture: '<',
      textCaptureModel: '=',
      textCapturePlaceholder: '@',
      textCaptureAutofocus: '<',
      isSoftSelected: '<',
      canClickSoftSelected: '<',
    },
  })

  /* @ngInject */
  function Controller(mediaView, cloudinaryService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.expandImage = expandImage
    ctrl.handleClick = handleClick

    function onInit() {
      ctrl.imageUrl = ctrl.image && cloudinaryService.optimize(ctrl.image)
      ctrl.radio = ctrl.type === 'radio'
      ctrl.checkbox = ctrl.type === 'checkbox'
    }

    function handleClick() {
      if (ctrl.isSoftSelected && ctrl.canClickSoftSelected === false) {
        return
      }
      ctrl.onClick()
    }

    function expandImage(event) {
      event.preventDefault()
      event.stopPropagation()
      mediaView.showImage(ctrl.imageUrl)
    }
  }
})()
